"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ServiceSettings = _interopRequireDefault(require("../ServiceSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Utility for extracting localization data.
 */
var LocalizationUtility = /*#__PURE__*/function () {
  function LocalizationUtility() {
    _classCallCheck(this, LocalizationUtility);
  }

  _createClass(LocalizationUtility, null, [{
    key: "getAppSettingValue",

    /**
     * Returns the key value.
     *
     * @param {object} localizationData Localization data from LocalizationService.
     * @param {object} keyName The key to retrieve value from.
     * @returns {string} The value of the requested key.
     */
    value: function getAppSettingValue(localizationData, keyName) {
      var localization = localizationData.localization || {};
      var appName = (_ServiceSettings.default.applicationName || '').toUpperCase();
      var appKeyName = appName + '__' + keyName;

      if (localization[appKeyName] !== undefined) {
        return localization[appKeyName];
      }

      if (localization[keyName] !== undefined) {
        return localization[keyName];
      }

      return null;
    }
  }]);

  return LocalizationUtility;
}();

exports.default = LocalizationUtility;